import React from "react";
import { Reveal, Overline } from "./Reveal";
import { ABOUT_IMG_SUB } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export function About() {
  const content = useContent();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal className="relative">
          <div className="overflow-hidden">
            <img src={content.about_image} alt="The Epic Center interior" className="w-full aspect-[4/5] object-cover" />
          </div>
          <div className="hidden md:block absolute -bottom-12 -right-6 w-48 lg:w-64 border-4 border-epic-black overflow-hidden">
            <img src={ABOUT_IMG_SUB} alt="Event detail" className="w-full aspect-square object-cover" />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <Overline>About The Venue</Overline>
          <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.95] mt-4">
            {content.about_heading}
          </h2>
          <div className="space-y-5 mt-7 text-epic-gray text-base md:text-lg leading-relaxed font-light">
            <p>{content.about_body1}</p>
            <p>{content.about_body2}</p>
          </div>
          <button
            data-testid="about-learn-more"
            onClick={() => go("venue-spaces")}
            className="mt-9 border border-epic-gold text-epic-gold bg-transparent hover:bg-epic-gold hover:text-epic-black font-bold uppercase tracking-widest text-sm px-8 py-4 transition-colors duration-300"
          >
            Learn More
          </button>
        </Reveal>
      </div>
    </section>
  );
}
